// Коффициент определяемый от общей площади предоставляемого земельного участка
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { backUrl } from "../../config";

const redPath = "k4Api"; // change
const tagApi = "k4s"; // change

export const k4Api = createApi({
  // change
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getK4: build.query({
      // change
      query: (param) => `${tagApi}${param ? param : ""}`,
      providesTags: [tagApi],
    }),
    createK4: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}`,
        method: "POST",
        body: {
          data: {
            ...newData,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
    updateK4: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}/${newData.id}`,
        method: "PUT",
        body: {
          data: {
            ...newData.updated,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const { useGetK4Query, useCreateK4Mutation, useUpdateK4Mutation } =
  k4Api; // change
